import "core-js/modules/es.function.name.js";
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default {
  name: 'TheCategoriesLabels',
  components: {
    NativeCarousel: NativeCarousel,
    NuxtLinkCustom: NuxtLinkCustom
  },
  props: {
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasScrollOnUnmount: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(props) {
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var carouselKey = computed(function () {
      var _props$categories;
      var category = (_props$categories = props.categories) === null || _props$categories === void 0 ? void 0 : _props$categories[0];
      return ((category === null || category === void 0 ? void 0 : category.label) || (category === null || category === void 0 ? void 0 : category.name)) + isMobile;
    });
    var linkToProperCategory = function linkToProperCategory(category) {
      return app.localePath({
        name: 'products-slug',
        params: {
          slug: category.slug
        }
      });
    };
    var carouselProps = useGlobalCauroselProps(computed(function () {
      return props.categories;
    }), {
      desktop: 4
    });
    onBeforeUnmount(function () {
      if (!props.hasScrollOnUnmount) return;
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    return {
      carouselProps: carouselProps,
      isMobile: isMobile,
      linkToProperCategory: linkToProperCategory,
      carouselKey: carouselKey
    };
  }
};